export default "__VITE_ASSET__hIpGuCWh__"